import { DialogModalStyle } from '@styles/common/modal/modalStyles';
import React, { useState } from 'react';
import { Button } from '@components/amc/Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Dialog = ({
  title,
  content,
  buttons,
  extraContent = null,
  footerClassName = ''
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  return /*#__PURE__*/_jsx(DialogModalStyle, {
    className: "modal",
    children: /*#__PURE__*/_jsxs("div", {
      className: `modal-content p-6`,
      children: [/*#__PURE__*/_jsxs("div", {
        className: `body`,
        children: [/*#__PURE__*/_jsx("div", {
          children: title
        }), /*#__PURE__*/_jsx("div", {
          children: content.map((content, index) => /*#__PURE__*/_jsx("div", {
            children: content === '' ? /*#__PURE__*/_jsx("br", {}) : content
          }, index))
        }), extraContent]
      }), /*#__PURE__*/_jsx("div", {
        className: `modal-footer ${footerClassName}`,
        children: buttons.map((button, index) => /*#__PURE__*/_jsx(Button, {
          variant: button.variant,
          size: "Large",
          text: button.text,
          type: button.type ?? 'button',
          disabled: button.disabled ?? isSubmitting,
          className: button.className,
          onClick: () => {
            setIsSubmitting(true);
            button.onClick?.();
          }
        }, index))
      })]
    })
  });
};
export default Dialog;